import { type AsyncStateObject, type Action, type PriorityList } from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, PRIORITY_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<PriorityList[]> = {
  data: [],
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const priorityListReducer = (
  state = INITIAL_STATE,
  action: Action<PriorityList[]>
): AsyncStateObject<PriorityList[]> => {
  switch (action.type) {
    case PRIORITY_ACTIONS.GET_PRIORITY_LIST + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case PRIORITY_ACTIONS.GET_PRIORITY_LIST + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case PRIORITY_ACTIONS.GET_PRIORITY_LIST + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: [],
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case PRIORITY_ACTIONS.GET_PRIORITY_LIST + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default priorityListReducer
